import React from 'react'
import { Modal } from '@frontend/ui-kit/agromarket/components/Modal'
import classNames from 'classnames'
import { Button } from '@/components/ui'
import { FieldEvaluationReportDialog } from '@/pages/Financing/components/FieldEvaluationReportDialogLauncher/components/FieldEvaluationReportDialog/FieldEvaluationReportDialog'
import { messages } from './messages'
import type { TIncreaseLoanAmountBannerProps } from './types'
import './styles.scss'

export const IncreaseLoanAmountBannerBase: React.FC<TIncreaseLoanAmountBannerProps> = ({
  className,
  title,
  buttonText,
  buttonModifiers,
  actionClassName,
  subtitleClassName,
  titleClassName,
  comment,
}) => {
  const handleClick = () => {
    Modal.show(FieldEvaluationReportDialog, {
      comment,
    })
  }

  return (
    <div className={classNames('increaseLoanAmountBannerBase', className)}>
      <h6 className={classNames('increaseLoanAmountBannerBase__title', titleClassName)}>{title}</h6>
      <div className={classNames('increaseLoanAmountBannerBase__subtitle text_small', subtitleClassName)}>{messages.subtitle}</div>
      <Button
        type="button"
        modifiers={buttonModifiers}
        className={classNames('increaseLoanAmountBannerBase__action', actionClassName)}
        onClick={handleClick}
      >
        {buttonText}
      </Button>
    </div>
  )
}
